<template>
  <!--电动车火情-->
  <div class="con flex-1">
    <div class="con-box flex flex-middle">
      <ul>
        <template>
          <li class="flex flex-middle">
            <span>腐蚀电流</span>
            <span :style="`color: ${colors1[0]}`">{{
              info.electricCurrent || "/"
            }}</span>
            <span>nA</span>
          </li>
          <li class="flex flex-middle">
            <span>电阻</span>
            <span :style="`color: ${colors1[1]}`">{{ "/" }}</span>
            <span>mΩ</span>
          </li></template
        >
        <!-- <template v-else>
          <li class="flex flex-middle">
            <span>气压</span>
            <span :style="`color: ${colors2[1]}`">{{
              info.airpress || "/"
            }}</span>
            <span>Pa</span>
          </li>
          <li class="flex flex-middle">
            <span>雨量值</span>
            <span :style="`color: ${colors2[0]}`">{{
              info.rainfallAmount || "/"
            }}</span>
            <span>mm</span>
          </li>
          <li class="flex flex-middle">
            <span>风速</span>
            <span :style="`color: ${colors2[0]}`">{{
              info.windSpeed || "/"
            }}</span>
            <span>m/s</span>
          </li>
        </template> -->
      </ul>
      <SimplePie
        id="SimplePie1"
        :color="colors1"
        :centerImg="$oss('CorrosionMonitorScreen/pie-img-2.png')"
      />
    </div>
    <div class="con-box flex flex-middle">
      <ul>
        <template>
          <li class="flex flex-middle">
            <span>环境温度</span>
            <span :style="`color: ${colors2[1]}`">{{
              info.temperature || "/"
            }}</span>
            <span>℃</span>
          </li>
          <li class="flex flex-middle">
            <span>环境湿度</span>
            <!-- 淡水腐蚀试验场环境湿度显示/ -->
            <span :style="`color: ${colors2[0]}`">{{
              deviceSn !== "864452066378991" ? info.humidity || "/" : "/"
            }}</span>
            <span>%</span>
          </li>
        </template>
        <!-- <template v-else
          ><li class="flex flex-middle">
            <span>空气温度</span>
            <span :style="`color: ${colors2[1]}`">{{
              info.temperature || "/"
            }}</span>
            <span>℃</span>
          </li>
          <li class="flex flex-middle">
            <span>空气湿度</span>
            <span :style="`color: ${colors2[0]}`">{{
              info.humidity || "/"
            }}</span>
            <span>%</span>
          </li></template
        > -->
      </ul>
      <SimplePie
        id="SimplePie2"
        :color="colors2"
        :centerImg="$oss('CorrosionMonitorScreen/pie-img-1.png')"
      />
    </div>
  </div>
</template>
<script>
import SimplePie from "./simplePie";
const INFO = {
  electricCurrent: "0",
  measureResistance: "0",
  referResistance: "0",
  temperature: "0",
  humidity: "0",
};
export default {
  components: {
    SimplePie,
  },
  props: {
    data: {
      default: () => ({}),
      type: Object,
    },
    dataActive: {
      default: 0,
      type: Number,
    },
    deviceSn: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      colors1: ["#FEE752", "#FDA735"],
      colors2: ["#526CFE", "#35FDF5"],
      resistanceAvg: 0,
      info: INFO,
    };
  },
  watch: {
    data: {
      handler(val) {
        this.resistanceAvg = 0;
        if (val) {
          this.info = val;
          if (val.measureResistance && val.referResistance) {
            this.resistanceAvg = (
              (parseFloat(val.measureResistance) +
                parseFloat(val.referResistance)) /
              2
            ).toFixed(2);
          }
        } else {
          this.info = INFO;
        }
      },
      immidiate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.con {
  display: grid;
  grid-template-rows: repeat(2, 50%);
  padding: calc(100vh / 1080 * 50) calc(100vw / 1920 * 20);
  &-box {
    position: relative;
    ul {
      width: 100%;
      display: grid;
      gap: calc(100vh / 1080 * 10);
      padding: calc(100vh / 1080 * 10) calc(100vw / 1920 * 50)
        calc(100vh / 1080 * 10) 0;
      height: calc(100vw / 1920 * 110);
      .pie-box {
      }
      li {
        background: linear-gradient(
          90deg,
          rgba(#0092c5, 0),
          rgba(#0092c5, 0.2)
        );
        color: rgba(#fff, 0.8);
        font-size: calc(100vw / 1920 * 14);
        span:nth-child(1) {
          width: 20%;
        }
        span:nth-child(2) {
          width: 40%;
          text-align: center;
          color: #fff;
          font-size: calc(100vw / 1920 * 24);
          font-weight: 600;
        }
        &:first-child {
          span {
            color: #a5eefc;
          }
        }
      }
    }
  }
}
</style>
